import { BrandlistFilterRequest } from './models/BrandlistRequest';
import api from "./axiosConfig";
import { InvoiceMasterPUTRequest } from "./models/InvoiceMasterRequest";

export const putInvoiceMaster = async (invId: string, inv: InvoiceMasterPUTRequest) => {
  return api.put(`/invoice/${invId}`, inv);
}

export const getInvoiceMaster = async (invId: string | undefined) => {
  return api.get(`/invoice/${invId}/master`);
}

export const getInvoiceDetails = async (invId: string | undefined) => {
  return api.get(`/invoice/${invId}/details`);
}

export const callDownloadCurrentInvoicesApi = async (pdf: boolean, excel: boolean, filter: BrandlistFilterRequest) => {
  return api.post('/invoice/download', {pdf: pdf, xlsx: excel, filter: filter}, {responseType: "blob"})
}

export const callDownloadInvoiceApi = async (invoiceId: string, pdf: boolean, excel: boolean) => {
  return api.post(`/invoice/${invoiceId}/download`, {pdf: pdf, xlsx: excel}, {responseType: "blob"})
}
